<template>
    <footer>
        <!-- <div style="padding: 10px 0;text-align: center;font-size: 12px">
            <div> © Copyright 2015-2022 IMC AII Rights Reserved</div>
            <div>
                俺来也(上海)网络科技有限公司
                <a style="color: #1E80FF" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备14051190号-7</a>
                <img src="http://website.anlaiye.com/uploadfile/image/20220721/20220721090341_79922.png" alt="" style="width: 20px;vertical-align: middle">
                <a style="color: #1E80FF" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402003336" target="_blank">沪公网安备31010402003336号</a>
            </div>
            <div>客服电话:400-6869-933</div>
        </div> -->
    </footer>
</template>

<script>
    export default {
        name: 'footer1',
        data() {
            return {

            };
        },
        methods: {

        }
    }
</script>


// WEBPACK FOOTER //
// Footer.vue?7b6b8f82